import { useMemo } from 'react';
import { validateLegTimeConflicts } from '@lp/features/RoutePlanner/utils';
import { AviaLegTypes, GroundLegTypes } from '@/api/apis/route';
import { RouteSegmentType } from '@/types/route';

export type UseLegWarningsParams = {
  leg: AviaLegTypes | GroundLegTypes;
  prevLeg?: AviaLegTypes | GroundLegTypes;
  segment: RouteSegmentType;
};

export const useLegWarnings = ({ leg, prevLeg, segment }: UseLegWarningsParams) => {
  return useMemo(() => {
    return validateLegTimeConflicts(segment, leg, prevLeg);
  }, [segment, leg, prevLeg]);
};
